import { useEffect, useState } from "react";

// Vrai lorsqu'un envoi dure plus de `delay` ms (réveil du serveur de formulaires).
export default function useSlowHint(loading, delay = 5000) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!loading) {
      setSlow(false);
      return undefined;
    }
    const timer = setTimeout(() => setSlow(true), delay);
    return () => clearTimeout(timer);
  }, [loading, delay]);
  return slow;
}

export const SLOW_HINT = "Connexion au service en cours… Cela peut prendre jusqu’à une minute : merci de ne pas fermer la page.";
